import { ShieldAlert } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { cn } from "@/lib/utils";

const DEFAULT_MESSAGE =
  "You don't have permission to view this page. Contact your administrator if you need access.";

interface AccessDeniedCardProps {
  
  message?: string;
  className?: string;
}

export function AccessDeniedCard({ message = DEFAULT_MESSAGE, className }: AccessDeniedCardProps) {
  return (
    <Card className={cn("rounded-lg border border-border", className)}>
      <CardContent className="flex flex-col items-center justify-center py-12 px-6 text-center">
        <div className="mb-4 text-muted-foreground">
          <ShieldAlert className="h-12 w-12" />
        </div>
        <h3 className="text-lg font-semibold">Access denied</h3>
        <p className="mt-2 text-sm text-muted-foreground">{message}</p>
      </CardContent>
    </Card>
  );
}
